import { Injectable } from '@angular/core';
import { AppInsightsService } from './app-insights.service';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root'
})
export class MonitoringService {

  constructor(private appInsights: AppInsightsService, private logging: LoggingService) {

  }

  logPageView(url: string, user: string, token: string) {
    this.appInsights.logPageView(url);
    this.logging.logPageView(url, user, token);
    console.info('Logged: ' + url);
  }
  startNavigationEvent(url: string) {
    this.appInsights.startTrackEvent(url);
  }
  endNavigationEvent(url: string) {
    this.appInsights.stopTrackEvent(url);
  }
}
